import React from 'react'
import { getImgProps, Img } from '@superhi/design'

import SyllabusProject from '../SyllabusProject'

import { API } from 'src/api'

export { default as FRAGMENT } from './fragments'

type Props = API.SyllabusListProjectImageComponent & { position: number }

const SyllabusProjectImage: React.FC<React.PropsWithChildren<Props>> = ({
  title,
  description,
  image,
  position,
}) => {
  const imageProps = React.useMemo(
    () =>
      getImgProps(
        image.url,
        {
          small: 90,
          medium: 50,
          large: 18,
          xlarge: 18,
        },
        {
          fm: 'png8',
        },
      ),
    [image],
  )

  return (
    <SyllabusProject
      title={title}
      position={position}
      description={description}
      header={<Img {...imageProps} aspectRatio="16:9" alt="" lazy isRounded />}
    />
  )
}

export default SyllabusProjectImage
